import CommandHandler from 'diagram-js/lib/command/CommandHandler';
import {select, Store} from '@ngrx/store';
import {State} from '@ispm-client/modules/bpmn-modeler/store/state';
import {take} from 'rxjs/operators';
import {selectFloatedNodesByLayer} from '@ispm-client/modules/bpmn-modeler/store/selectors/floating-nodes.selector';
import ElementRegistry from "diagram-js/lib/core/ElementRegistry";
import {PathwaysViewerCommands} from "@ispm/shared/bpmn-io/pathways-viewer-commands";
import {ModelingUtil} from "@ispm/shared/bpmn-io/modeling-util";
import {NodeType} from "@ispm/shared/bpmn-io/node-type";

export class FloatingNodesHandler implements CommandHandler {


    constructor(private store$: Store<State>, private elementRegistry: ElementRegistry, private pathwaysViewerCommands: PathwaysViewerCommands) {
    }

    postExecute(context): any {
        const layer = context.layer;
        const hide = context.hide;
        this.store$.pipe(select(selectFloatedNodesByLayer(layer)), take(1)).subscribe(floatedNodes => {
            this.toggleFloatedNodes(floatedNodes, hide);
        });
    }


    private toggleFloatedNodes(floatedNodesIds, hide: boolean): void {
        if (floatedNodesIds && floatedNodesIds.length > 0) {
            floatedNodesIds.forEach((floatedNodeId) => {
                const floatedNode = this.elementRegistry.get(floatedNodeId);
                if (floatedNode) {
                    this.toggleFloatingNextElementsVisibility(floatedNode, hide);
                }
            });
        }

    }

    private toggleFloatingNextElementsVisibility(element, hide: boolean): void {

        this.pathwaysViewerCommands.setElementVisibility(element, hide);
        const outgoingConnections = element.outgoing;
        const incomingConnection = element.incoming;
        for (const conn of incomingConnection) {
            this.pathwaysViewerCommands.setElementVisibility(conn, hide);
            this.pathwaysViewerCommands.setElementVisibility(conn.source, hide);
        }
        for (const conn of outgoingConnections) {
            // in case neighborhood entry node is floated, neighborhood head (target of neighborhood entry) should remain visible
            if (ModelingUtil.getNodeType(conn.target) !== NodeType.neighborhood_head) {
                this.pathwaysViewerCommands.setElementVisibility(conn, hide);
                this.pathwaysViewerCommands.setElementVisibility(conn.target, hide);

            }

        }


    }

}
